<template>
  <div :style="{ transform: `rotate(${rotation}deg)`, scale, display: 'block' }">
    <v-chip size="x-small" v-if="containerCount > 1" :color="borderColor" class="container-counter">
      {{ containerCount }}
    </v-chip>
    <svg
      width="30"
      height="100"
      viewBox="0 0 30 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29.5 1.30199L29.5 78.698C29.5 79.1736 29.1478 79.5 28.7838 79.5H1.21622C0.852207 79.5 0.5 79.1736 0.5 78.698L0.5 1.30199C0.5 0.826421 0.852209 0.5 1.21622 0.5L28.7838 0.5C29.1478 0.5 29.5 0.826422 29.5 1.30199Z"
        :fill="backgroundColor"
        :stroke="borderColor" />
      <path
        d="M7.5 15.5V13.8333H9.16667V15.5H7.5ZM7.5 12.1667V10.5H9.16667V12.1667H7.5ZM10.8333 15.5V13.8333H12.5V15.5H10.8333ZM10.8333 12.1667V10.5H12.5V12.1667H10.8333ZM14.1667 15.5V13.8333H15.8333V15.5H14.1667ZM14.1667 12.1667V10.5H15.8333V12.1667H14.1667ZM17.5 15.5V13.8333H19.1667V15.5H17.5ZM17.5 12.1667V10.5H19.1667V12.1667H17.5ZM20.8333 15.5V13.8333H22.5V15.5H20.8333ZM20.8333 12.1667V10.5H22.5V12.1667H20.8333Z"
        :fill="borderColor" />
      <path d="M25 79V81H5V79H25Z" :fill="borderColor" />
      <path
        d="M3.5 89V88.5H3H2.5C1.94772 88.5 1.5 88.9477 1.5 89.5V91.5C1.5 92.0523 1.94772 92.5 2.5 92.5H3H3.5V92V89Z"
        :fill="backgroundColor"
        :stroke="borderColor" />
      <path
        d="M26.5 81.5V97.2292C26.5 98.4939 25.5002 99.5 24.2903 99.5H5.70968C4.49977 99.5 3.5 98.4939 3.5 97.2292V81.5H26.5Z"
        :fill="backgroundColor"
        :stroke="borderColor" />
      <path
        d="M26.5 92L26.5 92.5L27 92.5L27.5 92.5C28.0523 92.5 28.5 92.0523 28.5 91.5L28.5 89.5C28.5 88.9477 28.0523 88.5 27.5 88.5L27 88.5L26.5 88.5L26.5 89L26.5 92Z"
        :fill="backgroundColor"
        :stroke="borderColor" />
    </svg>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import BaseSvgSpotEntity from './BaseSvgSpotEntity.vue';

export default defineComponent({
  name: 'SvgTruckAssetContainer',
  extends: BaseSvgSpotEntity,
  props: {
    containerCount: {
      type: Number,
      default: 1
    }
  }
});
</script>
<style lang="scss">
.container-counter {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}
</style>
